import { ISerializedError } from "./BasicWorker";

export interface WorkerMessage {
    id?: string;
    type: string;
    data?: any;
}

export interface WorkerResponseMessage {
    type: string;
    items: readonly WorkerResponseItem[];
    error?: string;
}

export interface WorkerResponseItem {
    id?: string;
    data?: any;
    exception?: ISerializedError;
}

/** Zpráva konfigurující worker, který potřebuje komunikovat s webovou službou */
export interface ICommunicationInitializationMessageData {
    /** Url služby, se kterou se má komunikovat */
    readonly communicationUrl: string;
    /** Zda se má komunikovat přes staré rozhraní webové služby */
    readonly useLegacyApi: boolean;
}
